/* 🤖 this file was generated by svg-to-ts */
export const mgcIconMap2Filled: {
  name: 'map-2-filled';
  data: string;
} = {
  name: 'map-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.65 3.029c-.071.009-.13.028-.13.044 0 .059 16.399 16.422 16.428 16.392.053-.052.063-14.52.011-14.825-.134-.782-.797-1.454-1.576-1.597-.166-.03-2.408-.041-7.42-.037-3.951.004-7.242.014-7.313.023M3.025 4.706C3.011 4.808 3 7.521 3 10.735v5.845l3.04-3.04 3.04-3.04-2.99-2.99C4.446 5.866 3.089 4.52 3.076 4.52c-.014 0-.037.084-.051.186m3.74 10.949L3.03 19.39l.07.215c.2.614.675 1.089 1.3 1.3.211.072.507.075 7.627.075 4.073 0 7.421-.014 7.438-.032.017-.017-1.993-2.056-4.467-4.53L10.5 11.92z"/></svg>`
};
